import React from "react";
import { Clock, FileText, Check, XCircle, PenLine, Truck } from "lucide-react";
import { API } from "./shared";

const STATUS_COLORS = { in_attesa: "bg-amber-100 text-amber-700", approvato: "bg-green-100 text-green-700", rifiutato: "bg-red-100 text-red-600" };
const STATUS_LABELS = { in_attesa: "In Attesa", approvato: "Approvato", rifiutato: "Rifiutato" };

export default function RequestsTable({ items, onApprove, onReject, onEdit, onCreateShipment }) {
  if (!items.length) return <div className="bg-white border border-zinc-200 rounded-sm p-8 text-center text-zinc-400">Nessuna richiesta</div>;
  const token = localStorage.getItem("mv_admin_token");
  return (
    <div className="space-y-2">
      {items.map((r, i) => (
        <div key={r.id || i} className="bg-white border border-zinc-200 rounded-sm px-4 py-3" data-testid={`request-row-${i}`}>
          <div className="flex items-center gap-3 flex-wrap">
            <div className="bg-amber-100 text-amber-600 w-8 h-8 rounded-sm flex items-center justify-center"><Clock size={16} /></div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm">{r.request_type === "uscita" ? "Uscita Merce" : "Preparazione"} — {r.company || r.client_name}</p>
              <p className="text-xs text-zinc-400">{r.items?.length || 0} articoli | {r.destination?.city || ""} | {r.created_at?.slice(0,10)}</p>
              {r.note && <p className="text-xs text-zinc-500 mt-1">Note: {r.note}</p>}
              {(r.order_number || r.shipment_tracking) && (
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  {r.order_number && <span className="px-1.5 py-0.5 bg-blue-50 text-blue-600 text-[10px] font-bold rounded">Ordine: {r.order_number}</span>}
                  {r.ddt_number && <span className="px-1.5 py-0.5 bg-zinc-100 text-zinc-600 text-[10px] font-bold font-mono rounded">{r.ddt_number}</span>}
                  {r.shipment_tracking && <span className="px-1.5 py-0.5 bg-purple-50 text-purple-700 text-[10px] font-bold rounded">SPED: {r.shipment_tracking}</span>}
                </div>
              )}
            </div>
            <span className={`px-2 py-1 text-[10px] font-bold uppercase rounded-sm ${STATUS_COLORS[r.status] || "bg-zinc-100 text-zinc-500"}`}>
              {STATUS_LABELS[r.status] || r.status}
            </span>
            <div className="flex items-center gap-1 flex-wrap">
              <button onClick={() => onEdit(r)} data-testid={`request-edit-${i}`}
                className="flex items-center gap-1 px-2 py-1.5 border border-zinc-200 text-[10px] font-bold uppercase rounded-sm hover:bg-zinc-50 text-zinc-600">
                <PenLine size={12} /> Modifica
              </button>
              <a href={`${API}/admin/warehouse/requests/${r.id}/pdf?token=${token}`} target="_blank" rel="noreferrer"
                data-testid={`request-pdf-${i}`}
                className="flex items-center gap-1 px-2 py-1.5 bg-[#09090B] text-white text-[10px] font-bold uppercase rounded-sm hover:bg-zinc-700">
                <FileText size={12} /> PDF
              </a>
              {r.status === "in_attesa" && (
                <>
                  <button onClick={() => onApprove(r.id)} className="p-1.5 bg-green-500 text-white rounded-sm hover:bg-green-600" data-testid={`approve-${i}`} title="Approva e crea ordine"><Check size={14} /></button>
                  <button onClick={() => onReject(r.id)} className="p-1.5 bg-red-500 text-white rounded-sm hover:bg-red-600" data-testid={`reject-${i}`} title="Rifiuta"><XCircle size={14} /></button>
                </>
              )}
              {r.request_type === "uscita" && !r.shipment_tracking && (
                <button onClick={() => onCreateShipment(r)} data-testid={`request-shipment-${i}`}
                  className="flex items-center gap-1 px-2 py-1.5 bg-[#FF5200] text-white text-[10px] font-bold uppercase rounded-sm hover:bg-[#e64a00]">
                  <Truck size={12} /> Crea Spedizione
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
